// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1057":"ef7ff22a397812ef","2139":"4deca7b1772be572","9484":"4dfa2e3f2030ae9f"}[chunkId] + ".css";
};